/**
 * Dependencies.
 */
import { BaseModel, endpoint, prop } from '@prz-dp/services';

/**
 * Export `ServicePointDeliverAlertModel`.
 */
@endpoint('alert/deliver')
export class ServicePointDeliverAlertModel extends BaseModel {
  /**
   * Properties.
   */
  @prop()
  code: string;

  @prop()
  name: string;

  /**
   * Constructor.
   */
  constructor(data: Partial<ServicePointDeliverAlertModel>) {
    super(data);
  }
}
